import { DatePicker } from 'antd';
import { LanguageContext } from 'contexts/LanguageContext';
import moment from 'moment';
import React, { useContext } from 'react';
import zhCN from 'antd/es/date-picker/locale/zh_CN';

interface Props {
  getDisabledDates: (pickableDate: moment.Moment | null) => boolean;
  setSelectedMonth: React.Dispatch<React.SetStateAction<number | null>>;
  setSelectedYear: React.Dispatch<React.SetStateAction<number | null>>;
}

export function MonthPicker({ getDisabledDates, setSelectedMonth, setSelectedYear }: Props) {
  const { MonthPicker } = DatePicker;
  const { dictionary } = useContext(LanguageContext);

  const onMonthChange = (date: moment.Moment | null, dateString: string) => {
    if (!date) {
      setSelectedYear(null);
      setSelectedMonth(null);
      return;
    }

    setSelectedMonth(date.month() + 1);
    setSelectedYear(date.year());
  };

  return (
    <MonthPicker
      disabledDate={getDisabledDates}
      onChange={onMonthChange}
      placeholder={dictionary.select_month}
      defaultValue={undefined}
      size="large"
      locale={zhCN}
    />
  );
}
